import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master-menu',
  templateUrl: './master-menu.component.html',
  styleUrls: ['./master-menu.component.css']
})
export class MasterMenuComponent implements OnInit {

  public show: boolean = false;
  public buttonName: any = 'Show';
  public userData: any = {};
  public activeMenu: string = '';
  public activeSubMenu: string = '';
  constructor(private router: Router) { }

  ngOnInit() {
    this.activeMenu = 'dashboard';
    if (this.router.url) {
      this.activeSubMenu = this.router.url;
      let urlArr = this.router.url.split("/");
      if (urlArr[1]) {

        this.activeMenu = urlArr[1];
        if (urlArr[1] == 'commissions' || urlArr[1] == 'designer') {
          this.activeMenu = 'staff';
          this.activeSubMenu = '/commissions/printer-commissions';
        }
        if (urlArr[2] && urlArr[2] == 'category-list' || urlArr[2] == 'style-list' || urlArr[2] == 'brand-list' || urlArr[2] == 'color-list' || urlArr[2] == 'fit-list' || urlArr[2] == 'group-list') {
          this.activeMenu = 'products';
          this.activeSubMenu = '/settings/category-list';
        }
        if (urlArr[2] && urlArr[2] == 'categories') {
          this.activeMenu = 'categories';
        }
        if (urlArr[2] && urlArr[2] == 'subscriber') {
          this.activeMenu = 'subscriber';
        }
        if (urlArr[2] && urlArr[2] == 'social-links' || urlArr[2] == 'site-logo' || urlArr[2] == 'api-detail') {
          this.activeSubMenu = '/settings/business-info';
        }
        if (urlArr[2] && urlArr[2] == 'smtp-mail-settings' || urlArr[2] == 'mail-template-settings') {
          this.activeSubMenu = '/settings/mail-settings';
        }
        if (urlArr[2] && urlArr[2] == 'print-position-list' || urlArr[2] == 'ink-settings-list') {
          this.activeSubMenu = '/settings/print-settings-form';
        }
        if (urlArr[2] && urlArr[2] == 'tax-request-approved') {
          this.activeSubMenu = '/settings/tax-verification-request';
        }
      }
    }
    this.userData = JSON.parse(localStorage.getItem('userDetails'));
  }

  toggle() {
    this.show = !this.show;
    if (this.show)
      this.buttonName = "SlideDown";
    else
      this.buttonName = "";
  }

}



// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/app/mnt-master/master-menu/master-menu.component.ts